import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

const commonStyles = css`
  font-family: Arial, sans-serif;
  font-size: 1.4rem; /* Responsive font size */
  font-weight: 400;
`;

const TextBoxContainer = styled.div`
  display: flex;
  flex-grow: 1;
`;

const TextBox = styled.input.attrs({
  type: 'text',
  inputMode: 'decimal',
})`
  ${commonStyles}
  width: 100%;
  height: 35px;
  padding-left: 0.5em;
  border: 1px solid #9A9A9A;
  border-radius: 0px;
  box-sizing: border-box;
  outline: none;
  color: #000000;

  &:hover {
    border-color: #0078c9;
  }
`;

const Label = styled.label`
  ${commonStyles}
  display: block;
  margin-bottom: 0.5em; /* Adjusted margin using em */
  font-family: Arial, sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
`;

const ErrorMessage = styled.span`
  ${commonStyles}
  width: 15em; /* Responsive width */
  color: red;
  font-size: 1.2rem;
  font-weight: 400;
  display: block;
  margin-top: 0.5em; /* Adjusted margin using em */
`;

const FormGroup = styled.div`
  margin-bottom: 1em; /* Adjusted margin using em */
`;

const TextBoxWithLabelSmart = ({ label, value, onChange }) => {
  const [error, setError] = useState('');
  const { i18n } = useTranslation();
  const locale = i18n.language;

  const numberFormatter = new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 20,
  });

  const parseNumber = (value) => {
    const example = numberFormatter.format(1.1);
    const decimalSeparator = example.charAt(1);
    const cleanedValue = value.replace(new RegExp(`[^0-9${decimalSeparator}]`, 'g'), '')
                              .replace(',', '.'); // Ensure consistent decimal point
    return parseFloat(cleanedValue);
  };

  const handleBlur = () => {
    const parsedValue = parseNumber(value);
    if (isNaN(parsedValue)) {
      setError('The input value was not a correct number');
    } else {
      setError('');
      onChange(numberFormatter.format(parsedValue));
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    onChange(value);
  };

  const handleKeyDown = (e) => {
    const key = e.key;
    const value = e.target.value;

    if (
      (key >= '0' && key <= '9') ||
      key === 'Backspace' ||
      key === 'Tab' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight' ||
      (key === '.' && !value.includes('.')) ||
      (key === ',' && !value.includes(','))
    ) {
      // Allow these keys
    } else {
      e.preventDefault();
    }
  };

  return (
    <FormGroup>
      <Label>{label}</Label>
      <TextBox
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder=""
      />
      {/*{error && <ErrorMessage>{error}</ErrorMessage>}*/}
    </FormGroup>
  );
};

export default TextBoxWithLabelSmart;